import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'osn-shared-redeem-input',
  templateUrl: './redeem-input.component.html',
  styleUrls: ['./redeem-input.component.scss'],
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Default,
  animations: [
    trigger('errorAnimation', [
      state('valid', style({ marginTop: '-24px', visibility: 'hidden', opacity: 0 })),
      state('invalid', style({ marginTop: '0px', visibility: 'visible', opacity: 1 })),
      transition('valid <=> invalid', animate('0.25s')),
    ]),
  ],
})
export class RedeemInputComponent implements OnInit, ControlValueAccessor, OnDestroy {
  @Input() public label: string;
  @Input() public type: string;
  @Input() public fallbackError = 'Invalid input';
  @Input() public gwError: string;
  @Input() public suffixIcon: string;
  @Input() public validIcon: string;
  @Input() public placeholder = '';
  @Input() public increasedIconSize = false;
  @Input() public readOnly = false;
  @ViewChild('inputField') public inputField: ElementRef;
  public tooltip: string;

  private readonly onDestroy$ = new Subject<void>();

  public disabled = false;
  public onChanged: any = () => {};
  public onTouched: any = () => {};
  public innerControl = new FormControl('');
  public inputFocused = false;

  constructor(public ngControl: NgControl, public elRef: ElementRef) {
    ngControl.valueAccessor = this;
  }

  public get showErrorMsg(): boolean {
    return (this.ngControl.invalid && this.innerControl.touched) || !!this.gwError;
  }

  public get isInputValid(): boolean {
    return this.ngControl.valid;
  }

  public ngOnInit(): void {
    this.innerControl.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe((val) => this.onChange(val));
  }

  public onFocus() {
    this.inputFocused = true;
  }

  public onBlur() {
    this.inputFocused = false;
  }

  public focus() {
    this.inputField.nativeElement.focus();
  }

  public onChange(val: string) {
    this.onChanged(val);
    this.onTouched();
  }

  public writeValue(val: string): void {
    if (val !== this.innerControl.value) {
      this.innerControl.setValue(val);
    }
  }
  public registerOnChange(fn: any): void {
    this.onChanged = fn;
  }
  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
